module.exports = __webpack_public_path__ + "static/media/MMI_logo.6e17f400.png";